import { styled, Modal, Backdrop } from '@mui/material';

export const GlobalBannersModal = styled(Modal)({
  '@media print': {
    position: 'absolute',
  },
});

export const GlobalBannersModalBackDrop = styled(Backdrop)({
  zIndex: -1,
  background: 'rgba(60, 16, 127, 0.5)',
  backdropFilter: 'blur(8px)',
});
